export default __webpack_public_path__ + "static/media/EfficientFrontier.b9c4472a.png";